import React from 'react';
import { Medal } from 'lucide-react';
import { Badge } from '../../types';
import ShareButton from '../social/ShareButton';

interface BadgeCardProps {
  badge: Badge;
  isNew?: boolean;
}

const BadgeCard: React.FC<BadgeCardProps> = ({ badge, isNew = false }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 flex items-center space-x-4">
      <div className="flex-shrink-0">
        <img referrerPolicy="no-referrer" src={badge.icon} alt={badge.name} className="h-12 w-12" />
      </div>
      <div>
        <h3 className="font-semibold text-gray-900">{badge.name}</h3>
        <p className="text-sm text-gray-600">{badge.description}</p>
      </div>
      <div className="ml-auto">
        <ShareButton achievement={badge} isNew={isNew} />
      </div>
    </div>
  );
};

export default BadgeCard;
